<script setup lang="ts">
import { type PropType, ref } from 'vue';
import type { ResetPasswordFirstStepData } from '../types/steps';
import BaseFormGroup from '~/shared/components/form/base-form-group.vue';
import BaseInput from '~/shared/components/form/input/base-input.vue';

defineProps({
  emailErrors: {
    type: Object as PropType<{ email: string }>,
    required: true,
  },
});

const data = defineModel({
  type: Object as PropType<ResetPasswordFirstStepData>,
  required: true,
});
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="bg-gray-light border border-stroke-primary p-4 c-text-secondary w-80 rounded-lg">
      A verification code will be sent to your email.
    </div>

    <div class="flex flex-col gap-4 w-80 relative">
      <BaseFormGroup name="email" :error="emailErrors?.email || ''" label="Email">
        <BaseInput
          id="email" v-model="data.email" name="email" placeholder="Enter Email" :error="emailErrors?.email || ''"
        />
      </BaseFormGroup>
    </div>
  </div>
</template>
